import React, {Component} from 'react';
import { FormGroup, Label, Input, Card, CardBody, CardHeader, ListGroup, Alert, Table, Row, Col, Button } from 'reactstrap';
import ImClient from "../service/ImClientSingleton"
import ApprovableListItem from "../discrepancy/ApprovableListItem";
import ApprovablesTable from "../discrepancy/ApprovablesTable";

function _filterReserveApprovals(approvables) {
    return approvables.filter(a => a.transaction.type.name !== "STORE-RESV-ADD-FRM-INVENTORY-INBOUND");
}

class ManageDiscrepancies extends Component {
    constructor(props) {
        super(props);

        this.state = {
            recentApprovables: [],
            pendingApprovables: []
        }
    }

    componentDidMount() {
        this.refreshSate();
    }

    refreshSate(){
        ImClient.getPendingApprovables()
            .then(approvables => {
                this.setState({pendingApprovables: _filterReserveApprovals(approvables)})
            });
        ImClient.getApprovables()
            .then(approvables => {
                this.setState({recentApprovables: _filterReserveApprovals(approvables)})
            });
    }

    renderPendingApprovals(){
        if(this.state.pendingApprovables.length === 0)
            return "";

        return (
            <div>
                <h2>Pending Approval</h2>
                <ApprovablesTable approvables={this.state.pendingApprovables}/>
            </div>
        )
    }

    render() {
        return (
            <div className="App-Width">
                <h1>Manage Discrepancies</h1>
                {this.renderPendingApprovals()}
                <h2>Recent Discrepancies</h2>
                <ApprovablesTable approvables={this.state.recentApprovables}/>
            </div>
        );
    }
}

export default ManageDiscrepancies;
